import React, { useEffect, useState } from "react";
import "./GroupLoansViewPayments.scss";
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Menu, MenuItem, Typography } from "@mui/material";
import { commonRunQuery } from "../../../util/API/loans";
import CloseIcon from "@mui/icons-material/Close";
import GroupLoansTable from "../../../components/GroupLoansTable/GroupLoansTable";
import { getLoanRepayments } from "../../../util/API/loandisk";
import BaseDrawer from "../../../components/UI/BaseDrawer/BaseDrawer";

const GroupLoansViewPayments = ({ selectedLoan, setLoansListView, selectedMemberName }) => {
    const [paymentsListView, setLateFeesListView] = useState(null);
    const [loanPayments, setLoanPayments] = useState([]);
    const [anchorEl, setAnchorEl] = useState(null);
    const [selectedPayment, setSelectedPayment] = useState(null);
    const [openDetailsDialog, setOpenDetailsDialog] = useState(false);
    const [openDetailsDrawer, setOpenDetailsDrawer] = useState(false);

    useEffect(()=> {
        console.log("GroupLoansViewPayments_useEffect==========",selectedLoan);
        getLoanPayments();
    },[selectedLoan]);

    const getLoanPayments = async() => {
        try {
            const response = await commonRunQuery(237, selectedLoan?.li?.loanid);
            if ( response?.data?.header?.callStatus === "1" && response?.data?.header?.reccount !== "0" ) {
                const paymentsArray = Array.isArray(response?.data?.body?.record)
                        ? response?.data?.body?.record
                        : [response?.data?.body?.record];
      
                setLoanPayments(paymentsArray);
              console.log("getLoanPayments_response==========",paymentsArray);
            } else {
                setLoanPayments([]);
            }
      
        } catch (error) {
            console.log("getLoanPayments_error==========",error);
            
        }
    }

    const columns = [
        {
          label: 'Payment Id',
          getValue: (row) => row?.loanapplied?.paymentid ?? ''
        },
        {
          label: 'Amount Applied',
          getValue: (row) => row?.loanapplied?.amountapplied ?? '',
          align: 'right',
          amount: true
        },
        {
            label: 'Apply Id',
            getValue: (row) => row?.loanapplied?.applyid ?? ''
        },
        {
          label: 'Payment Date',
          getValue: (row) => row?.loanpayments?.paymentdate ?? ''
        }
    ];

    const handleMenuOpen = (event, loan) => {
        console.log("handleMenuOpen------------",loan)
        setAnchorEl(event.currentTarget);
        setSelectedPayment(loan);
    };

    const handleMenuClose = () => {
        console.log("handleMenuClose------------")
        setAnchorEl(null);
    };

    return (
        <Box>
            {
                paymentsListView == null && <Box className="d-flex justify-content-between">
                    <Typography
                    sx={{
                        fontFamily: "'Nunito'",
                        fontStyle: "normal",
                        fontWeight: 500,
                        fontSize: "21.4825px",
                        color: "#3A3A3A",
                    }}
                    className=""
                    >
                        View Payments - {selectedMemberName}
                    </Typography>

                    <Button
                        className="fs-size-12 paiy-blue text-white"
                        variant="contained"
                        color="primary"
                        onClick={() => {
                            setLoansListView(null);
                        }}
                    >
                        Return
                    </Button>
                </Box>
            }

            {
                paymentsListView == null &&
                <Box>
                    <GroupLoansTable 
                        data={loanPayments} 
                        columns={columns} 
                        title="Loan Payments" 
                        formatRow={(row) => [
                            row?.loanapplied?.paymentid,
                            row?.loanapplied?.amountapplied,
                            row?.loanapplied?.applyid,
                            row?.loanpayments?.paymentdate,
                        ]} 
                        handleMenuOpen={handleMenuOpen}
                        viewMenu={true}
                        downloads={false}
                        // author={`${user?.user?.firstName} ${user?.user?.lastName}`} 
                    />
                </Box>
            }

            <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleMenuClose}>
                <MenuItem
                    onClick={() => {
                        // setOpenDetailsDialog(true);
                        setOpenDetailsDrawer(true);
                        handleMenuClose();
                    }}
                >
                    View Details
                </MenuItem>
            </Menu>

            <BaseDrawer
                open={openDetailsDrawer}
                handleClose={() => setOpenDetailsDrawer(false)}
                height="75vh"
                className="loanProductInfoDrawer"
                overflow="auto"
            >
                {selectedPayment && (
                    <Box>
                        <Box className="user-accounts-tab">
                            <Box className="balance-container">
                                <Box className="row" display="flex" flexWrap="wrap" gap={4}>
                                    {/* Left Column */}
                                    <Box minWidth="300px" flex={1}>
                                        {[ 
                                            { label: "Loan ID", value: selectedPayment?.loanapplied?.loanid },
                                            { label: "User ID", value: selectedPayment?.loanapplied?.userid },
                                            { label: "Applied Amount", value: selectedPayment?.loanapplied?.amountapplied },
                                            { label: "Apply Id", value: selectedPayment?.loanapplied?.applyid },
                                            { label: "Currency Code", value: selectedPayment?.loanapplied?.currcode },
                                            { label: "External Ref No", value: selectedPayment?.loanapplied?.confirmationrefno || "N/A" },
                                            { label: "Loan Status", value: selectedPayment?.loanapplied?.status === "1" ? "Confirmed" : "Pending" },
                                            { label: "Confirmation Time", value: selectedPayment?.loanapplied?.confirmationtime || "N/A" },
                                            { label: "Loan Type", value: selectedPayment?.loanapplied?.loandesc || "N/A" },
                                            { label: "Payment Plan Id", value: selectedPayment?.loanapplied?.paymentplanid },
                                        ].map(({ label, value }, index) => (
                                            <Box className="info-container" key={index}>
                                                <Box className="info-type">{label}:</Box>
                                                <Box className="info-response">{value || "N/A"}</Box>
                                            </Box>
                                        ))}
                                    </Box>

                                    {/* Right Column */}
                                    <Box minWidth="300px" flex={1}>
                                        {[ 
                                            { label: "Total Amount Applied", value: selectedPayment?.loanapplied?.totalamountapplied },
                                            { label: "Fees Applied", value: selectedPayment?.loanapplied?.feesapplied },
                                            { label: "Tax Amount Breakdown", value: selectedPayment?.loanapplied?.taxamountbreakdown },
                                            { label: "Fee System Breakdown", value: selectedPayment?.loanapplied?.feesystembreakdown },
                                            { label: "Fee External Breakdown", value: selectedPayment?.loanapplied?.feeexternalbreakdown },
                                            { label: "Fee Franchisee Breakdown", value: selectedPayment?.loanapplied?.feefranchiseebreakdown },
                                            { label: "Fee Reseller Breakdown", value: selectedPayment?.loanapplied?.feeresellerbreakdown },
                                            { label: "Payment Date", value: selectedPayment?.loanpayments?.paymentdate || "N/A" },
                                        ].map(({ label, value }, index) => (
                                            <Box className="info-container" key={index}>
                                                <Box className="info-type">{label}:</Box>
                                                <Box className="info-response">
                                                    {value || "N/A"}
                                                </Box>
                                            </Box>
                                        ))}
                                    </Box>
                                </Box>
                            </Box>
                        </Box>
                    </Box>
                )}
            </BaseDrawer>

            {/* <Dialog
                open={openDetailsDialog}
                onClose={() => setOpenDetailsDialog(false)}
                fullWidth
                maxWidth="sm"
                className="loans-dialog"
            >
                <DialogTitle>
                    <Box>
                        Payment Details
                        <Box sx={{ position: "absolute", top: 8, right: 8, width: 40, height: 40 }}>
                            <IconButton onClick={() => setOpenDetailsDialog(false)} sx={{ zIndex: 1, color: "#6c757d", "&:hover": { color: "#000" } }}>
                                <CloseIcon />
                            </IconButton>
                        </Box>
                    </Box>
                </DialogTitle>
                <DialogContent dividers>
                    {selectedPayment && (
                        <Box>
                            <Box className="user-accounts-tab">
                                <Box className="balance-container">
                                    <Box className="row" display="flex" flexWrap="wrap" gap={4}>
                                        <Box minWidth="300px" flex={1}>
                                            {[ 
                                                { label: "Loan ID", value: selectedPayment?.loanapplied?.loanid },
                                                { label: "User ID", value: selectedPayment?.loanapplied?.userid },
                                                { label: "Applied Amount", value: selectedPayment?.loanapplied?.amountapplied },
                                                { label: "Apply Id", value: selectedPayment?.loanapplied?.applyid },
                                                { label: "Currency Code", value: selectedPayment?.loanapplied?.currcode },
                                                { label: "External Ref No", value: selectedPayment?.loanapplied?.confirmationrefno || "N/A" },
                                                { label: "Loan Status", value: selectedPayment?.loanapplied?.status === "1" ? "Confirmed" : "Pending" },
                                                { label: "Confirmation Time", value: selectedPayment?.loanapplied?.confirmationtime || "N/A" },
                                                { label: "Loan Type", value: selectedPayment?.loanapplied?.loandesc || "N/A" },
                                                { label: "Payment Plan Id", value: selectedPayment?.loanapplied?.paymentplanid },
                                            ].map(({ label, value }, index) => (
                                                <Box className="info-container" key={index}>
                                                    <Box className="info-type">{label}:</Box>
                                                    <Box className="info-response">{value || "N/A"}</Box>
                                                </Box>
                                            ))}
                                        </Box>

                                        <Box minWidth="300px" flex={1}>
                                            {[ 
                                                { label: "Total Amount Applied", value: selectedPayment?.loanapplied?.totalamountapplied },
                                                { label: "Fees Applied", value: selectedPayment?.loanapplied?.feesapplied },
                                                { label: "Tax Amount Breakdown", value: selectedPayment?.loanapplied?.taxamountbreakdown },
                                                { label: "Fee System Breakdown", value: selectedPayment?.loanapplied?.feesystembreakdown },
                                                { label: "Fee External Breakdown", value: selectedPayment?.loanapplied?.feeexternalbreakdown },
                                                { label: "Fee Franchisee Breakdown", value: selectedPayment?.loanapplied?.feefranchiseebreakdown },
                                                { label: "Fee Reseller Breakdown", value: selectedPayment?.loanapplied?.feeresellerbreakdown },
                                                { label: "Payment Date", value: selectedPayment?.loanpayments?.paymentdate || "N/A" },
                                            ].map(({ label, value }, index) => (
                                                <Box className="info-container" key={index}>
                                                    <Box className="info-type">{label}:</Box>
                                                    <Box className="info-response">
                                                        {value || "N/A"}
                                                    </Box>
                                                </Box>
                                            ))}
                                        </Box>
                                    </Box>
                                </Box>
                            </Box>
                        </Box>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpenDetailsDialog(false)} color="primary">
                        Close
                    </Button>
                </DialogActions>
            </Dialog> */}
        </Box>
    )
}

export default GroupLoansViewPayments;
